import { useState } from "react";
import { useT } from "../i18n";
import { DEVICE_CATEGORIES } from "../vault/devices";

// Inline create dialog for a folder or device node (replaces window.prompt chains).
export function NewNodeDialog({
  kind,
  initial,
  submitLabel,
  onClose,
  onCreate,
}: {
  kind: "folder" | "device";
  initial?: { name: string; category?: string; address?: string };
  submitLabel?: string;
  onClose: () => void;
  onCreate: (name: string, category?: string, address?: string) => void;
}) {
  const t = useT();
  const [name, setName] = useState(initial?.name ?? "");
  const [category, setCategory] = useState(initial?.category ?? "Network");
  const [address, setAddress] = useState(initial?.address ?? "");
  const submit = () => {
    if (name.trim()) onCreate(name.trim(), category, address.trim());
  };
  return (
    <div className="fixed inset-0 z-50 grid place-items-center bg-black/60" onClick={onClose}>
      <div className="w-[420px] rounded-md border border-border bg-panel shadow-xl" onClick={(e) => e.stopPropagation()}>
        <div className="border-b border-border px-4 py-3 font-semibold">{kind === "device" ? t("New device") : t("New folder")}</div>
        <div className="flex flex-col gap-3 px-4 py-4 text-sm">
          <input
            autoFocus
            placeholder={kind === "device" ? t("Device name:") : t("New folder name:")}
            value={name}
            onChange={(e) => setName(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && submit()}
            className="rounded border border-border bg-panel2 px-2 py-1.5 text-xs outline-none focus:border-accent"
          />
          {kind === "device" && (
            <>
              <label className="text-xs text-muted">{t("Category")}</label>
              <select value={category} onChange={(e) => setCategory(e.target.value)} className="rounded border border-border bg-panel2 px-2 py-1.5 text-xs outline-none focus:border-accent">
                {DEVICE_CATEGORIES.map((c) => (
                  <option key={c} value={c}>{c}</option>
                ))}
              </select>
              <input
                placeholder={t("Address / hostname (optional):")}
                value={address}
                onChange={(e) => setAddress(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && submit()}
                className="rounded border border-border bg-panel2 px-2 py-1.5 text-xs outline-none focus:border-accent"
              />
            </>
          )}
          <div className="flex justify-end gap-2">
            <button onClick={onClose} className="rounded border border-border px-3 py-1.5 text-xs hover:border-accent">{t("Cancel")}</button>
            <button onClick={submit} disabled={!name.trim()} className="rounded bg-accent px-3 py-1.5 text-xs font-medium text-white hover:bg-accent2 disabled:opacity-60">{submitLabel ?? t("Create")}</button>
          </div>
        </div>
      </div>
    </div>
  );
}
